import React from 'react';
import classnames from 'classnames';
import UnfoldIcon from '../../assets/images/icons/unfold.png';
import UnfoldIconLight from '../../assets/images/icons/light/filter_icon_dropdown.png';
import { connect } from 'react-redux';
// import '../../assets/styles/components/instrument/bid-ask.scss';
import { stockActions } from '../../actions/trading/stock.action';
import { ACTION_TYPE } from "../../constants/w-socket";
import { WS_LANG_KEY } from '../../constants/app';
import { utilsFunction, formatFunctions, Converter } from "../../helpers/functions";
import { dataType as types } from '../../constants/data-type';
import LoadingLayer from '../Spinner/LoadingLayer';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { getCompanyRender, getInitState } from '@/helpers/global';

const initStateFunc = getInitState({
  TTLDefaultData: [
    {
      value: '-',
      id: 0,
      name: 'market_quote_open',
      field: 'open'
    },
    {
      value: '-',
      id: 1,
      name: 'market_quote_high',
      field: 'high'
    },
    {
      value: '-',
      id: 2,
      name: 'market_quote_tumover',
      field: 'turnover'
    },
    {
      value: '-',
      id: 3,
      name: 'market_quote_prev_close',
      field: 'prev'
    },
    {
      value: '-',
      id: 4,
      name: 'market_quote_low',
      field: 'low'
    },
    {
      value: '-',
      id: 5,
      name: 'market_quote_tumover_rate',
      field: 'turnoverRate',
      type: types.PERCENT
    },
    {
      value: '-',
      id: 6,
      name: 'market_quote_vol',
      field: 'vol',
      type:types.NUMBER
    },
    {
      value: '-',
      id: 7,
      name: 'market_quote_mkt_cap',
      field: 'marketCap'
    },
    {
      value: '-',
      id: 8,
      name: 'market_quote_pb',
      field: 'pbRatio',
      type: types.PERCENT
    }
  ],
  EIFDefaultData: [
    {
      value: '-',
      id: 0,
      name: 'market_quote_open',
      field: 'open'
    },
    {
      value: '-',
      id: 1,
      name: 'market_quote_prev_close',
      field: 'prev'
    },
    {
      value: '-',
      id: 2,
      name: 'market_quote_high',
      field: 'high'
    },
    {
      value: '-',
      id: 3,
      name: 'market_quote_low',
      field: 'low'
    },
    {
      value: '-',
      id: 4,
      name: 'market_quote_tumover',
      field: 'turnover'
    },
    {
      value: '-',
      id: 5,
      name: 'market_quote_tumover_rate',
      field: 'turnoverRate',
      type: types.PERCENT
    },
    {
      value: '-',
      id: 6,
      name: 'market_quote_vol',
      field: 'vol'
    },
    {
      value: '-',
      id: 7,
      name: 'market_quote_pb',
      field: 'pbRatio',
      type: types.PERCENT
    },
    {
      value: '-',
      id: 8,
      name: 'market_quote_mkt_cap',
      field: 'marketCap'
    },
    {
      value: '-',
      id: 9,
      name: 'market_quote_h_mkt_cap',
      field: 'h_mkt_cap'
    },
    {
      value: '-',
      id: 10,
      name: 'market_quote_52wk_high',
      field: 'w52High'
    },
    {
      value: '-',
      id: 11,
      name: 'market_quote_52wk_low',
      field: 'w52Low'
    },
    {
      value: '-',
      id: 12,
      name: 'market_quote_h_shares',
      field: 'circCapital'
    },
    {
      value: '-',
      id: 13,
      name: 'market_quote_change',
      field: 'change'
    },
    {
      value: '-',
      id: 14,
      name: 'market_quote_dividend_percent',
      field: 'yield'
    },
    {
      value: '-',
      id: 15,
      name: 'market_quote_dividend_percent',
      field: 'yield'
    },
    {
      value: '-',
      id: 16,
      name: 'market_quote_p_elyr',
      field: 'p_elyr'
    },
    {
      value: '-',
      id: 17,
      name: 'market_quote_epslyr',
      field: 'epslyr'
    },
    {
      value: '-',
      id: 18,
      name: 'market_quote_shares',
      field: 'totalCapital'
    },
    {
      value: '',
      id: 19,
      name: '',
      field: ''
    }
  ],
  CMBIDefaultData: [
    {
      value: '-',
      id: 0,
      name: 'market_quote_open',
      field: 'open'
    },
    {
      value: '-',
      id: 1,
      name: 'market_quote_high',
      field: 'high'
    },
    {
      value: '-',
      id: 2,
      name: 'market_quote_tumover',
      field: 'turnover'
    },
    {
      value: '-',
      id: 3,
      name: 'market_quote_prev_close',
      field: 'prev'
    },
    {
      value: '-',
      id: 4,
      name: 'market_quote_low',
      field: 'low'
    },
    {
      value: '-',
      id: 5,
      name: 'market_quote_tumover_rate',
      field: 'turnoverRate',
      type: types.PERCENT
    },
    {
      value: '-',
      id: 6,
      name: 'market_quote_vol',
      field: 'vol'
    },
    {
      value: '-',
      id: 7,
      name: 'market_quote_mkt_cap',
      field: 'marketCap'
    },
    {
      value: '-',
      id: 8,
      name: 'market_quote_pb',
      field: 'pbRatio',
      type: types.PERCENT
    }
  ],
  BASICDefaultData: [
    {
      value: '-',
      id: 0,
      name: 'market_quote_open',
      field: 'open'
    },
    {
      value: '-',
      id: 1,
      name: 'market_quote_prev_close',
      field: 'prev'
    },
    {
      value: '-',
      id: 2,
      name: 'market_quote_high',
      field: 'high'
    },
    {
      value: '-',
      id: 3,
      name: 'market_quote_low',
      field: 'low'
    },
    {
      value: '-',
      id: 4,
      name: 'market_quote_tumover',
      field: 'turnover'
    },
    {
      value: '-',
      id: 5,
      name: 'market_quote_tumover_rate',
      field: 'turnoverRate',
      type: types.PERCENT
    },
    {
      value: '-',
      id: 6,
      name: 'market_quote_vol',
      field: 'vol'
    },
    {
      value: '-',
      id: 7,
      name: 'market_quote_pb',
      field: 'pbRatio',
      type: types.PERCENT
    },
    {
      value: '-',
      id: 8,
      name: 'market_quote_mkt_cap',
      field: 'marketCap'
    },
    {
      value: '-',
      id: 9,
      name: 'market_quote_h_mkt_cap',
      field: 'h_mkt_cap'
    },
    {
      value: '-',
      id: 10,
      name: 'market_quote_52wk_high',
      field: 'w52High'
    },
    {
      value: '-',
      id: 11,
      name: 'market_quote_52wk_low',
      field: 'w52Low'
    },
    {
      value: '-',
      id: 12,
      name: 'market_quote_h_shares',
      field: 'circCapital'
    },
    {
      value: '-',
      id: 13,
      name: 'market_quote_change',
      field: 'change'
    },
    {
      value: '-',
      id: 14,
      name: 'market_quote_dividend_percent',
      field: 'yield'
    },
    {
      value: '-',
      id: 15,
      name: 'market_quote_dividend_percent',
      field: 'yield'
    },
    {
      value: '-',
      id: 16,
      name: 'market_quote_p_elyr',
      field: 'p_elyr'
    },
    {
      value: '-',
      id: 17,
      name: 'market_quote_epslyr',
      field: 'epslyr'
    },
    {
      value: '-',
      id: 18,
      name: 'market_quote_shares',
      field: 'totalCapital'
    },
    {
      value: '',
      id: 19,
      name: '',
      field: ''
    }
  ],
  FUBONDefaultData: [
    {
      value: '-',
      id: 0,
      name: 'market_quote_open',
      field: 'open'
    },
    {
      value: '-',
      id: 1,
      name: 'market_quote_high',
      field: 'high'
    },
    {
      value: '-',
      id: 2,
      name: 'market_quote_tumover',
      field: 'turnover'
    },
    {
      value: '-',
      id: 3,
      name: 'market_quote_prev_close',
      field: 'prev'
    },
    {
      value: '-',
      id: 4,
      name: 'market_quote_low',
      field: 'low'
    },
    {
      value: '-',
      id: 5,
      name: 'market_quote_tumover_rate',
      field: 'turnoverRate',
      type: types.PERCENT
    },
    {
      value: '-',
      id: 6,
      name: 'market_quote_vol',
      field: 'vol'
    },
    {
      value: '-',
      id: 7,
      name: 'market_quote_mkt_cap',
      field: 'marketCap'
    },
    {
      value: '-',
      id: 8,
      name: 'market_quote_pb',
      field: 'pbRatio',
      type: types.PERCENT
    }
  ],
  TTLExpandData: [
    {
      value: '-',
      id: 0,
      name: 'market_quote_change',
      field: 'change'
    },
    {
      value: '-',
      id: 1,
      name: 'market_quote_52wk_high',
      field: 'w52High'
    },
    {
      value: '-',
      id: 2,
      name: 'market_quote_52wk_low',
      field: 'w52Low'
    },
    {
      value: '-',
      id: 3,
      name: 'market_quote_shares',
      field: 'totalCapital'
    },
    {
      value: '-',
      id: 4,
      name: 'market_quote_h_mkt_cap',
      field: 'h_mkt_cap'
    },
    {
      value: '-',
      id: 5,
      name: 'market_quote_h_shares',
      field: 'circCapital',
      type:types.NUMBER
    },
    {
      value: '-',
      id: 6,
      name: 'market_quote_p_elyr',
      field: 'p_elyr'
    },
    {
      value: '-',
      id: 7,
      name: 'market_quote_epslyr',
      field: 'epslyr'
    },
    {
      value: '-',
      id: 8,
      name: 'market_quote_dividend_percent',
      field: 'yield'
    },
    {
      value: '-',
      id: 9,
      name: 'market_quote_dividend',
      field: 'dividend'
    }
  ],
  EIFExpandData: [],
  CMBIExpandData: [
    {
      value: '-',
      id: 0,
      name: 'market_quote_52wk_low',
      field: 'w52Low'
    },
    {
      value: '-',
      id: 1,
      name: 'market_quote_change',
      field: 'change'
    },
    {
      value: '-',
      id: 2,
      name: 'market_quote_52wk_high',
      field: 'w52High'
    },
    {
      value: '-',
      id: 3,
      name: 'market_quote_h_shares',
      field: 'circCapital'
    },
    {
      value: '-',
      id: 4,
      name: 'market_quote_shares',
      field: 'totalCapital'
    },
    {
      value: '-',
      id: 5,
      name: 'market_quote_h_mkt_cap',
      field: 'h_mkt_cap'
    },
    {
      value: '-',
      id: 6,
      name: 'market_quote_dividend_percent',
      field: 'yield'
    },
    {
      value: '-',
      id: 7,
      name: 'market_quote_p_elyr',
      field: 'p_elyr'
    },
    {
      value: '-',
      id: 8,
      name: 'market_quote_epslyr',
      field: 'epslyr'
    }
  ],
  BASICExpandData: [],
  FUBONExpandData: [
    {
      value: '-',
      id: 0,
      name: 'market_quote_change',
      field: 'change'
    },
    {
      value: '-',
      id: 1,
      name: 'market_quote_52wk_high',
      field: 'w52High'
    },
    {
      value: '-',
      id: 2,
      name: 'market_quote_52wk_low',
      field: 'w52Low'
    },
    {
      value: '-',
      id: 3,
      name: 'market_quote_shares',
      field: 'totalCapital'
    },
    {
      value: '-',
      id: 4,
      name: 'market_quote_h_mkt_cap',
      field: 'h_mkt_cap'
    },
    {
      value: '-',
      id: 5,
      name: 'market_quote_h_shares',
      field: 'circCapital'
    },
    {
      value: '-',
      id: 6,
      name: 'market_quote_p_elyr',
      field: 'p_elyr'
    },
    {
      value: '-',
      id: 7,
      name: 'market_quote_epslyr',
      field: 'epslyr'
    },
    {
      value: '-',
      id: 8,
      name: 'market_quote_dividend_percent',
      field: 'yield'
    },
    {
      value: '-',
      id: 9,
      name: 'market_quote_dividend',
      field: 'dividend'
    }
  ],

  TTLEpslyrFormatter(res) {
    return res.peRatio ? utilsFunction.currencyFormatter(res.peRatio) : '-'
  },
  SCBEpslyrFormatter(res) {
    return res.peRatio ? res.peRatio : '-'
  },
  EIFEpslyrFormatter(res) {
    return res.peRatio ? res.peRatio : '-'
  },
  CMBIEpslyrFormatter(res) {
    return res.peRatio ? res.peRatio : '-'
  },
  FUBONEpslyrFormatter(res) {
    return res.peRatio ? utilsFunction.currencyFormatter(res.peRatio) : '-'
  }
})


const renderComponents = {
  TTLContent() {
    const { defaultData, expandData, isMinimize } = this.state;
    const { language , theme,isMobile} = this.props;
    return (
      <>
        <div style={{ width: '100%' }}>
          {defaultData.map(i => (
            <div key={i.id} className='item'  style={{width:isMobile && '45%'}} >
              <span>{language[i.name]}</span>
             { i.name =='market_quote_vol' ? <span>{i.value.split('.')[0]}</span> : <span>{this.formatNumber(i.value)}</span>}
            </div>
          ))}
        </div>
        <div className={classnames('expand-index', !isMinimize && 'expand-index-open')} style={{maxHeight:(isMobile && !isMinimize) && '130px'}}  >
          {expandData.map(i => (
            <div key={i.id} className='item' style={{width:isMobile && '45%'}} >
              <span>{language[i.name]}</span>
              <span>{this.formatNumber(i.value)}</span>
            </div>
          ))}
        </div>
        {isMinimize ? (
          <img className='unfold_icon' src={theme ==='light'?UnfoldIconLight : UnfoldIcon} alt='fold_icon' onClick={() => this.setState({ isMinimize: false })} />
        ) : (
          <img className='fold_icon' src={theme ==='light'?UnfoldIconLight : UnfoldIcon} alt='fold_icon' onClick={() => this.setState({ isMinimize: true })} />
        )}
      </>
    )
  },
  EIFContent() {
    const { defaultData } = this.state;
    const { language } = this.props;
    return (
      <>
        <div style={{ width: '100%' }}>
          {defaultData.map(i => (
            <div key={i.id} className='item' style={i.id % 2 === 0 || i.id === 0 ? { paddingRight: '22px' } : {}}>
              <span>{language[i.name]}</span>
              <span>{this.formatNumber(i.value)}</span>
            </div>
          ))}
        </div>
      </>
    )
  },
  CMBIContent() {
    const { defaultData, expandData, isMinimize } = this.state;
    const { language } = this.props;
    return (
      <>
        <div style={{ width: '100%' }}>
          {defaultData.map(i => (
            <div key={i.id} className='item'>
              <span>{language[i.name]}</span>
              <span>{this.formatNumber(i.value)}</span>
            </div>
          ))}
        </div>
        <div className={classnames('expand-index', !isMinimize && 'expand-index-open')}>
          {expandData.map(i => (
            <div key={i.id} className='item'>
              <span>{language[i.name]}</span>
              <span>{this.formatNumber(i.value)}</span>
            </div>
          ))}
        </div>
        {isMinimize ? (
          <img className='unfold_icon' src={UnfoldIcon} alt='fold_icon' onClick={() => this.setState({ isMinimize: false })} />
        ) : (
          <img className='fold_icon' src={UnfoldIcon} alt='fold_icon' onClick={() => this.setState({ isMinimize: true })} />
        )}
      </>
    )
  },
  FUBONContent() {
    const { defaultData, expandData, isMinimize } = this.state;
    const { language , theme} = this.props;
    return (
      <>
        <div style={{ width: '100%' }}>
          {defaultData.map(i => (
            <div key={i.id} className='item'>
              <span>{language[i.name]}</span>
              { i.name =='market_quote_vol' ? <span>{i.value.split('.')[0]}</span> : <span>{this.formatNumber(i.value)}</span>}
            </div>
          ))}
        </div>
        <div className={classnames('expand-index', !isMinimize && 'expand-index-open')}>
          {expandData.map(i => (
            <div key={i.id} className='item'>
              <span>{language[i.name]}</span>
              { i.name =='market_quote_h_shares' ? <span>{i.value.split('.')[0]}</span> : <span>{this.formatNumber(i.value)}</span>}
            </div>
          ))}
        </div>
        {isMinimize ? (
          <img className='unfold_icon' src={theme ==='light'?UnfoldIconLight : UnfoldIcon} alt='fold_icon' onClick={() => this.setState({ isMinimize: false })} />
        ) : (
          <img className='fold_icon' src={theme ==='light'?UnfoldIconLight : UnfoldIcon} alt='fold_icon' onClick={() => this.setState({ isMinimize: true })} />
        )}
      </>
    )
  }
}

class InstrumentIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMinimize: true,
      defaultData: initStateFunc('TTLDefaultData'),
      expandData: initStateFunc('TTLExpandData'),
      load: false
    }
    this.renderComponents = getCompanyRender(renderComponents)
    this.renderContent = this.renderComponents({ name: 'TTLContent' })
  }
  render() {
    const { load } = this.state;
    return (
      <div className={classnames("instrument-index", `instrument-index-${iTradeEnv.company}`)}>
        <LoadingLayer load={load} />
        { this.renderContent() }
      </div>
    )
  }

  formatNumber = (num) => {
    if (!num) return num
    let numArr = String(num).split(',')
    if (numArr.length === 5) {
      return `${numArr[0]}${numArr[1] === '000' ? '' : '.' + numArr[1]}T`
    } else if (numArr.length === 4) {
      return `${numArr[0]}${numArr[1] === '000' ? '' : '.' + numArr[1]}B`
    } else if (numArr.length === 3) {
      return `${numArr[0]}${numArr[1] === '000' ? '' : '.' + numArr[1]}M`
    } else {
      return num
    }
  }

  getFinancial = () => {
    const { marketParams, language, mdsToken } = this.props;
    if (!(marketParams.marketID && marketParams.stockCode && mdsToken)){
      this.setState({  defaultData: this.state.defaultData.map(v => (v.value = '-', v)), expandData: this.state.expandData.map(v => (v.value = '-', v)) })
      return
    } 
    this.setState({ load:true})
    if (marketParams.marketID === 'USEX') {
      stockActions.getStatisticsAction({symbols: [{ exchangeID: "XNYS", key: marketParams.stockCode}]}, statisticsRes => {
        if (statisticsRes.rtnCode) return
        const defaultData = this.state.defaultData.map(item => {
          if (statisticsRes[item.field]) {
            item.value = formatFunctions.dataFormat(statisticsRes[item.field], types.CURRENCY)
          } else if (item.field === 'vol') {
            item.value = formatFunctions.dataFormat(statisticsRes['volume'], types.CURRENCY)
          }
          return item
        })
        this.setState({ defaultData, load: false })
      })

      stockActions.getClosingPriceAction({symbols: [{ exchangeID: "XNYS", key: marketParams.stockCode}]}, closingPriceRes => {
        if (closingPriceRes.rtnCode) return
        const defaultData = this.state.defaultData.map(item => {
          if (item.field === 'prev') {
            item.value = formatFunctions.dataFormat(closingPriceRes['closingPrice'], types.CURRENCY)
          }
          return item
        })
        this.setState({ defaultData, load: false })
      })
    } else {
      let params = {
        symbol:
        {
          exchangeID: Converter.mappingWebSocketMarket(marketParams.marketID),
          key: Converter.mappingStockCode(marketParams.stockCode)
        },
        language: utilsFunction.switchToolTipsLanguage(language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
      }
  
      this.props.getFinancialData(params, res => {
        const infoParmas = {
          sessID: mdsToken,
          symbols: [params.symbol]
        }
        let originData = this.state.defaultData;
        let paddingData = this.state.expandData;
        let financialData = originData.map(item => {
          if (item.type === types.PERCENT && res[item.field]) {
            item.value = `${parseInt(res[item.field] * 100)}%`
            return item
          } else if (res[item.field]) {
            item.value = formatFunctions.dataFormat(res[item.field], types.CURRENCY)
            return item
          } else {
            return item
          }
        })
  
        let financialPaddingData = paddingData.map(item => {
          if (res[item.field]) {
            item.value = formatFunctions.dataFormat(res[item.field], types.CURRENCY)
            return item
          } else if (item.field === 'epslyr') {
            item.value = initStateFunc('TTLEpslyrFormatter', res)
            return item
          } else if (item.field === 'p_elyr') {
            item.value = res.earnps ? res.earnps : '-'
            return item
          } else if (item.field === 'dividend') {
            item.value = res.dividend ? res.dividend : '-'
            return item
          } else {
            return item
          }
        })
  
        this.props.getDetailPriceInfoData(infoParmas, detailRes => {
          let detailData = financialData.map(item => {
            if (item.type === types.PERCENT && detailRes[item.field]) {
              item.value = `${parseInt(detailRes[item.field] * 100)}%`
              return item
            } else if (detailRes[item.field]) {
              item.value = formatFunctions.dataFormat(detailRes[item.field], types.CURRENCY)
              return item
            } else {
              return item
            }
          })
  
          let paddingDetailData = financialPaddingData.map(item => {
            if (item.field === 'change') {
              item.value = (detailRes.last && detailRes.prev) ? formatFunctions.dataFormat(detailRes.last - detailRes.prev, types.CURRENCY) : '-'
              return item
            } else if (item.field === 'h_mkt_cap') {
              item.value = (res.circCapital && detailRes.last) ? formatFunctions.dataFormat(res.circCapital * detailRes.last, types.CURRENCY) : '-'
              return item
            } if (detailRes[item.field]) {
              item.value = formatFunctions.dataFormat(detailRes[item.field], types.CURRENCY)
              return item
            } else {
              return item
            }
          })
  
          this.setState({
            defaultData: detailData,
            expandData: paddingDetailData,
            load: false
          })
        })
        this.setState({
          load: false
        })
      })
    }

  }

  componentDidMount() {
    this.getFinancial()
  }

  componentDidUpdate(preProps) {
    const { marketParams, mdsToken } = this.props;
    if (marketParams && JSON.stringify(preProps.marketParams) !== JSON.stringify(marketParams) || preProps.mdsToken !== mdsToken) {
      this.getFinancial()
    }
  }

  componentWillUnmount() {
    this.setState = () => {}
  }
}

InstrumentIndex.defaultProps = {
  instrument: {}
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    stockCode: state.trade.stockCode,
    marketParams: state.trade.marketParams,
    mdsToken: state.trade.mdsToken,
    theme:state.app.theme,
    isMobile: state.app.isMobile,
  }),
  dispatch => ({
    getFinancialData: (p, c, e) => stockActions.getFinancialAction(p, c, e),
    getDetailPriceInfoData: (p, c, e) => dispatch(stockActions.getDetailPriceInfoAction(p, c, e))
  })
)(InstrumentIndex)
